import script from "./AdminCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCoupons.vue?vue&type=script&setup=true&lang=js"

import "./AdminCoupons.vue?vue&type=style&index=0&id=515b95bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-515b95bb"]])

export default __exports__